import script from "./customDataRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./customDataRow.vue?vue&type=script&setup=true&lang=ts"

import "./customDataRow.vue?vue&type=style&index=0&id=e5e94e94&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5e94e94"]])

export default __exports__